import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Alert, Button, CircularProgress } from "@mui/material";

import NoWorkspaceAccess from "app/common/workspace/NoWorkspaceAccess";
import {
  bootstrapWorkspaces,
  recoverWorkspaceAccess,
} from "app/store/modules/actions/workspaces.actions";

export default function WorkspaceBootstrapGate({ children }) {
  const dispatch = useDispatch();
  const { bootstrapStatus, bootstrapError, available } = useSelector((state) => state.workspaces);
  const userId = useSelector((state) => state.auth.user?._id);

  useEffect(() => {
    if (userId && bootstrapStatus === "idle") dispatch(bootstrapWorkspaces());
  }, [bootstrapStatus, dispatch, userId]);

  useEffect(() => {
    const handleWorkspaceError = () => dispatch(recoverWorkspaceAccess());
    window.addEventListener("workspace-access-error", handleWorkspaceError);
    return () => window.removeEventListener("workspace-access-error", handleWorkspaceError);
  }, [dispatch]);

  if (bootstrapStatus === "ready") return children;
  if (bootstrapStatus === "empty") return <NoWorkspaceAccess workspaces={available} />;
  if (bootstrapStatus === "error") {
    return (
      <main className="container py-10">
        <Alert
          severity="error"
          action={
            <Button color="inherit" onClick={() => dispatch(bootstrapWorkspaces())}>
              Retry
            </Button>
          }
        >
          {bootstrapError?.message || "We could not load your workspaces."}
        </Alert>
      </main>
    );
  }

  return (
    <div className="d-flex justify-content-center py-10">
      <CircularProgress aria-label="Loading workspaces" />
    </div>
  );
}
